// A small legend on the galaxy map (issue #39): what the capital, a relay, a star in range and a relay being built
// look like. Dismissed once, it stays dismissed on this device; storage that throws (private mode) just shows it.
import { useState } from 'preact/hooks';
import { t } from '../i18n/index.js';
import { hideLegend, legendHidden } from './maplegend.js';

export function MapLegend() {
  const [hidden, setHidden] = useState(legendHidden);
  if (hidden) return null;
  return (
    <div class="maplegend" role="note" aria-label={t('legend')}>
      <span><i class="lg-cap">★</i>{t('mapLegendCapital')}</span>
      <span><i class="lg-relay" />{t('mapLegendRelay')}</span>
      <span><i class="lg-range" />{t('mapLegendInRange')}</span>
      <span><i class="lg-build" />{t('mapLegendBuilding')}</span>
      <button class="lg-x" aria-label={t('mapLegendHide')} title={t('mapLegendHide')} onClick={() => { hideLegend(); setHidden(true); }}>✕</button>
    </div>
  );
}
